import { AddonType } from '../products/addon.model';

export enum PortalType {
  WORDPRESS_PLUGIN = 'WORDPRESS_PLUGIN',
  EBAY = 'EBAY',
  IMMOBILIENSCOUT24_DE = 'IMMOBILIENSCOUT24_DE',
  IMMONET_DE = 'IMMONET_DE',
  IMMOWELT_DE = 'IMMOWELT_DE',
  IVD = 'IVD',
  IMMOBILIENSCOUT24_HM_DE = 'IMMOBILIENSCOUT24_HM_DE',
  IMMOBILIENSCOUT24_GC_DE = 'IMMOBILIENSCOUT24_GC_DE',
  RESIDENT_APP = 'RESIDENT_APP',
  WILLHABEN = 'WILLHABEN',
  IMMOBILIE1 = 'IMMOBILIE1',
  CS_PRO = 'CS_PRO',
  IMMOMIO_PORTAL = 'IMMOMIO_PORTAL'
}

export enum ImmomioPortalType {
  HOMEPAGE_MODULE = 'HOMEPAGE_MODULE'
}

export enum ImmoscoutTypes {
  PORTAL = 'portal',
  CUSTOM = 'custom',
  MODULE = 'module'
}

export interface PortalConfig {
  fullName: string;
  portalId: PortalType | ImmomioPortalType;
  imgUrl: string;
  logoUrl?: string; // in case of limited space we want to show square logo instead full length image
  skipValidation: boolean;
  iframeUrl?: string;
  passwordLabel?: string;
  useImmoscoutForm?: boolean;
  userNameLabel?: string;
  validationControl?: string;
  subType?: ImmoscoutTypes;
  addon?: AddonType;
  state?: string;
  name?: string;
  isUserConfigDisabled?: boolean;
}

export enum PropertyPortalSourceType {
  // General Types
  INTERNAL_APPLY_LINK = 'INTERNAL_APPLY_LINK',
  RESIDENT_APP = 'RESIDENT_APP',
  IMMOMIO_PORTAL = 'IMMOMIO_PORTAL',
  IMMOMIO_PORTAL_LANDLORD = 'IMMOMIO_PORTAL_LANDLORD',
  IMMOMIO_PORTAL_GLOBAL = 'IMMOMIO_PORTAL_GLOBAL',
  // Homepage Module Types
  HOMEPAGE_MODULE_INTERNAL = 'HOMEPAGE_MODULE_INTERNAL',
  HOMEPAGE_MODULE_EXTERNAL = 'HOMEPAGE_MODULE_EXTERNAL',
  // Portal Types
  IMMOBILIENSCOUT24_REFERENCE = 'IMMOBILIENSCOUT24_REFERENCE',
  IMMOBILIENSCOUT24_REDIRECT = 'IMMOBILIENSCOUT24_REDIRECT',
  KALAYDO_DE_REFERENCE = 'KALAYDO_DE_REFERENCE',
  KALAYDO_DE_REDIRECT = 'KALAYDO_DE_REDIRECT',
  IMMOBILIEN_DE_REFERENCE = 'IMMOBILIEN_DE_REFERENCE',
  IMMOBILIEN_DE_REDIRECT = 'IMMOBILIEN_DE_REDIRECT',
  IMMONET_DE_REFERENCE = 'IMMONET_DE_REFERENCE',
  IMMONET_DE_REDIRECT = 'IMMONET_DE_REDIRECT',
  IMMOWELT_DE_REFERENCE = 'IMMOWELT_DE_REFERENCE',
  IMMOWELT_DE_REDIRECT = 'IMMOWELT_DE_REDIRECT',
  IVD_REFERENCE = 'IVD_REFERENCE',
  IVD_REDIRECT = 'IVD_REDIRECT',
  EBAY_REFERENCE = 'EBAY_REFERENCE',
  EBAY_REDIRECT = 'EBAY_REDIRECT',
  IMMOEXPERTEN_REFERENCE = 'IMMOEXPERTEN_REFERENCE',
  IMMOEXPERTEN_REDIRECT = 'IMMOEXPERTEN_REDIRECT',
  WORDPRESS_PLUGIN_REFERENCE = 'WORDPRESS_PLUGIN_REFERENCE',
  WORDPRESS_PLUGIN_REDIRECT = 'WORDPRESS_PLUGIN_REDIRECT',
  WILLHABEN_REFERENCE = 'WILLHABEN_REFERENCE',
  WILLHABEN_REDIRECT = 'WILLHABEN_REDIRECT',
  IMMOBILIE1_REFERENCE = 'IMMOBILIE1_REFERENCE',
  IMMOBILIE1_REDIRECT = 'IMMOBILIE1_REDIRECT',
  CS_PRO_REFERENCE = 'CS_PRO_REFERENCE',
  CS_PRO_REDIRECT = 'CS_PRO_REDIRECT'
}
